const { AreaCalculator } = require('./AreaCalculator.js');
const { RoomForm } = require('./RoomForm.js');

const RoomCalculator = {
	components: {
		RoomForm,
		AreaCalculator
	},

	props: {
		prefillFromStore: {
			type: Boolean,
			default: false
		}
	},

	emits: ['room-saved'],

	setup(props, { emit }) {
		const { computed } = Vue;
		const { useStore } = Vuex;

		const store = useStore();
		const productType = computed(() => store.state.productType);

		const prefillData = computed(() => {
			if (!props.prefillFromStore || !store.state.area || store.state.area <= 0) {
				return null;
			}
			return {
				unitType: store.state.unit || 'm2',
				width: store.state.width || null,
				length: store.state.length || null,
				area: store.state.area
			};
		});

		const onRoomsChanged = ({ rooms, primaryRoomIndex }) => {
			if (rooms.length > 0) {
				let projectSize = rooms[primaryRoomIndex - 1].projectSize;
				store.dispatch('setUnit', 'm2');

				if (store.state.productType === 'roll') {
					let rollWidth = store.state.rollWidths[0];
					let rollLength = projectSize / Number(rollWidth);
					store.dispatch('setWidth', Number(rollWidth));
					store.dispatch('setLength', Number(rollLength).toFixed(2));
					store.dispatch('setArea', Number(rollLength) * Number(rollWidth));
				} else {
					store.dispatch('setArea', projectSize);
				}
			}
		};

		const onRoomDeleted = ({ rooms }) => {
			if (rooms.length === 0) {
				store.dispatch('setArea', 0);
				store.dispatch('setLength', 0);
			}
		};

		const onRoomSaved = () => {
			emit('room-saved');
		};

		return {
			productType,
			prefillData,
			onRoomsChanged,
			onRoomDeleted,
			onRoomSaved
		};
	},

	template: `
		<RoomForm
			variant="product"
			:prefillData="prefillData"
			@rooms-changed="onRoomsChanged"
			@room-deleted="onRoomDeleted"
			@room-saved="onRoomSaved"
		>
			<template #room-list-extra>
				<AreaCalculator v-if="productType == 'roll'" class="mt-5" />
			</template>
		</RoomForm>
	`
};

module.exports = { RoomCalculator };
